import React from "react";
import styled from "styled-components";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';

import {
    makeStyles,
} from "@material-ui/core";


const StepIcon = styled.span`
  background: ${props => props.active ? "#000000" : "unset"};
  color: ${props => props.active ? "#FFFFFF" : "#000000"};
  margin-right: 10px;
  width: 25px;
  height: 25px;
  display: inline-block;
  border: 1px solid #000000;
  border-radius: 20px;
  position: relative;
  ::before {
    content: "${props => props.num}";
    top: 2.2px;
    left: 50%;
    width: 9.7px;
    text-align: center;
    margin-left: -4px;
    position: absolute;
    font-size: 14px;
  }
`;

const StepDiv = styled.span`
  display: inline-block;
  width: 20px;
  border-bottom: 1px solid #BCBCBC;
  transform: translate(10px, -10px);
  margin-right: 25px;
  margin-left: 8px;
`;

const StepMobileDiv = styled.span`
  display: block;
  border-left: 1px solid #BCBCBC;
  width: 1px;
  height: 13px;
  margin-left: 13px;
  margin-bottom: 5px;
`;

const StepName = styled.span`
  vertical-align: super;
`;

const useStylesAll = makeStyles(theme => ({

}));

function RegisterProgressBar(props) {
    const { step } = props;
    const { t, i18n } = useTranslation('register');

    return (
        <Grid item xs={12}>
            <Grid component={Box} item xs={12} display={{ xs: "none", md: "block" }} style={{whiteSpace: "nowrap"}}>
                <StepIcon active={step == '1'} num="1"/><StepName>{t('info')} </StepName><StepDiv />
                <StepIcon active={step == '2'} num="2" /><StepName>{t('plan')}</StepName><StepDiv />
                <StepIcon active={step == '3'} num="3" /><StepName>{t('gift')}</StepName><StepDiv />
                <StepIcon active={step == '4'} num="4" /><StepName>{t('donation')}</StepName><StepDiv />
                <StepIcon active={step == '5'} num="5" /><StepName>{t('payment')}</StepName>
            </Grid>
            <Grid component={Box} item xs={12} display={{ xs: "block", md: "none" }}>
                <Grid container spacing={0}>
                    <Grid item xs={12} style={{ whiteSpace: 'nowrap' }} p={0}>
                        <StepIcon active={step == '1'} num="1" /><StepName>{t('info')}</StepName><StepMobileDiv />
                    </Grid>
                    <Grid item xs={12} style={{ whiteSpace: 'nowrap' }} p={0}>
                        <StepIcon active={step == '2'} num="2" /><StepName>{t('plan')}</StepName><StepMobileDiv />
                    </Grid>
                    <Grid item xs={12} style={{ whiteSpace: 'nowrap' }} p={0}>
                        <StepIcon active={step == '3'} num="3" /><StepName>{t('gift')}</StepName><StepMobileDiv />
                    </Grid>
                    <Grid item xs={12} style={{ whiteSpace: 'nowrap' }} p={0}>
                        <StepIcon active={step == '4'} num="4" /><StepName>{t('donation')}</StepName><StepMobileDiv />
                    </Grid>
                    <Grid item xs={12} style={{ whiteSpace: 'nowrap' }} p={0}>
                        <StepIcon active={step == '5'} num="5" /><StepName>{t('payment')}</StepName>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default RegisterProgressBar;
